"use strict";

exports.__esModule = true;
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/

function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    br: "br",
    strong: "strong",
    a: "a",
    hr: "hr",
    ul: "ul",
    li: "li",
    code: "code",
    h2: "h2",
    pre: "pre",
    em: "em"
  }, (0, _react.useMDXComponents)(), props.components);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.p, {
      children: " "
    }), "\n", "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: [(0, _jsxRuntime.jsx)(_components.br, {}), "\n", "Theme UI is a library for creating themeable user interfaces based on constraint-based\ndesign principles. Build custom component libraries, design systems, web applications,\nGatsby themes, and more with a flexible API for best-in-class developer ergonomics."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: [(0, _jsxRuntime.jsxs)(_components.strong, {
        children: [(0, _jsxRuntime.jsx)(_components.a, {
          href: "https://github.com/system-ui/theme-ui/tree/stable",
          children: "stable"
        }), " docs"]
      }), ": ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://theme-ui.com",
        children: "https://theme-ui.com"
      }), " ", (0, _jsxRuntime.jsx)(_components.br, {}), "\n", (0, _jsxRuntime.jsxs)(_components.strong, {
        children: [(0, _jsxRuntime.jsx)(_components.a, {
          href: "https://github.com/system-ui/theme-ui/tree/develop",
          children: "develop"
        }), " (prerelease) docs"]
      }), ": ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://dev.theme-ui.com",
        children: "https://dev.theme-ui.com"
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.hr, {}), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Built for design systems, white-labels, themes, and other applications where\ncustomizing colors, typography, and layout are treated as first-class citizens\nand based on a standard ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://system-ui.com/theme",
        children: "Theme Specification"
      }), ", Theme UI is intended to work in\na variety of applications, libraries, and other UI components. Colors,\ntypography, and layout styles derived from customizable theme-based design\nscales help you build UI rooted in constraint-based design principles."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The next evolution of Styled System"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "From the creators of utility-based, atomic CSS methodologies"
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Theme-based styling with the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "sx"
        }), " prop"]
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Compatible with virtually any UI component library"
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Works with existing ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://styled-system.com",
          children: "Styled System"
        }), " components"]
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Quick mobile-first responsive styles"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Built-in support for dark modes"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Primitive page layout components"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Completely customizable with robust theming"
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Built with a standard ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://system-ui.com/theme",
          children: "Theme Specification"
        }), " for interoperability"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Built with ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://emotion.sh",
          children: "Emotion"
        }), " for scoped styles"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Plugin for use in ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://gatsbyjs.org",
          children: "Gatsby"
        }), " sites and themes"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Style ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://mdxjs.com",
          children: "MDX"
        }), " content with a simple, expressive API"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Works with ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://github.com/KyleAMathews/typography.js",
          children: "Typography.js"
        }), " themes"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "getting-started",
      children: "Getting Started"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-sh",
        children: "npm install theme-ui @emotion/react\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: [(0, _jsxRuntime.jsxs)(_components.em, {
        children: ["If you don't need color modes or components you can install\n", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://github.com/system-ui/theme-ui/tree/develop/packages/core",
          children: (0, _jsxRuntime.jsx)(_components.strong, {
            children: "@theme-ui/core"
          })
        })]
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Any styles in your app can reference values from the global ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "theme"
      }), " object. To\nprovide the theme in context, wrap your application with the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "ThemeUIProvider"
      }), "\ncomponent and pass in a custom ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "theme"
      }), " object."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-jsx",
        children: "// basic usage\nimport { ThemeUIProvider } from 'theme-ui'\nimport theme from './theme'\n\nexport default (props) => (\n  <ThemeUIProvider theme={theme}>{props.children}</ThemeUIProvider>\n)\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "theme"
      }), " object follows the System UI\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://theme-ui.com/theme-spec/",
        children: "Theme Specification"
      }), ", which lets you define\ncustom color palettes, typographic scales, fonts, and more. Read more about\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://theme-ui.com/theming",
        children: "theming"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "// example theme.js\nexport default {\n  fonts: {\n    body: 'system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif',\n    heading: '\"Avenir Next\", sans-serif',\n    monospace: 'Menlo, monospace',\n  },\n  colors: {\n    text: '#000',\n    background: '#fff',\n    primary: '#33e',\n  },\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.h2, {
      id: "sx-prop",
      children: [(0, _jsxRuntime.jsx)(_components.code, {
        children: "sx"
      }), " prop"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "sx"
      }), " prop works similarly to Emotion's ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "css"
      }), " prop, accepting style objects\nto add CSS directly to an element in JSX, but includes extra theme-aware\nfunctionality. Using the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "sx"
      }), " prop for styles means that certain properties can\nreference values defined in your ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "theme"
      }), " object. This is intended to make\nkeeping styles consistent throughout your app the easy thing to do."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "sx"
      }), " prop only works in modules that have defined a custom pragma at the top\nof the file, which replaces the default React JSX functions. This means you can\ncontrol which modules in your application opt into this feature without the need\nfor a Babel plugin or additional configuration."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-jsx",
        children: "/** @jsxImportSource theme-ui */\n\nexport default (props) => (\n  <div\n    sx={{\n      fontWeight: 'bold',\n      fontSize: 4, // picks up value from `theme.fontSizes[4]`\n      color: 'primary', // picks up value from `theme.colors.primary`\n    }}\n  >\n    Hello\n  </div>\n)\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Read more about\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://theme-ui.com/guides/how-it-works/#jsx-pragma",
        children: "how the custom pragma works"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "responsive-styles",
      children: "Responsive styles"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "sx"
      }), " prop also supports using arrays as values to change properties\nresponsively with a mobile-first approach. This API originated in ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://styled-system.com",
        children: "Styled\nSystem"
      }), " and is intended as\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://styled-system.com/guides/array-props",
        children: "a terser syntax for applying responsive styles"
      }), "\nacross a singular dimension."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-jsx",
        children: "/** @jsxImportSource theme-ui */\n\nexport default (props) => (\n  <div\n    sx={{\n      // applies width 100% to all viewport widths,\n      // width 50% above the first breakpoint,\n      // and 25% above the next breakpoint\n      width: ['100%', '50%', '25%'],\n    }}\n  />\n)\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.hr, {}), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "documentation",
      children: "Documentation"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/theming",
          children: "Theming"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsxs)(_components.a, {
          href: "https://theme-ui.com/sx-prop",
          children: ["The ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "sx"
          }), " Prop"]
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/layout",
          children: "Layout"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/color-modes",
          children: "Color Modes"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/theme-spec",
          children: "Theme Spec"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/themed",
          children: "Themed"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/mdx-components",
          children: "MDX Components"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/packages/gatsby-plugin",
          children: "Gatsby Plugin"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://theme-ui.com/api",
          children: "API"
        })
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "MIT License"
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "contributors-",
      children: "Contributors ✨"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Thanks goes to these wonderful people\n(", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://allcontributors.org/docs/en/emoji-key",
        children: "emoji key"
      }), "):"]
    }), "\n", "\n", "\n", "\n", "\n", "\n", "\n", "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["This project follows the\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/all-contributors/all-contributors",
        children: "all-contributors"
      }), "\nspecification. Contributions of any kind welcome!"]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = MDXContent;
exports.default = _default;